export default __webpack_public_path__ + "static/media/610.f7f2542c.gif";